var map = {
	"./Alle Pramien.jpg": "80eb",
	"./Bad & Wellness.jpg": "6e09",
	"./Bestseller.jpg": "55c9",
	"./Bucher & Zeitschriften.jpg": "0464",
	"./Gutscheine.jpg": "5300",
	"./Haus,  Wohnen & Garten.jpg": "d5d7",
	"./Kindertraume & Spiele.jpg": "27c9",
	"./Kochen & Genuss.jpg": "3556",
	"./Multimedia & Technik.jpg": "100b",
	"./Neue Pramien.jpg": "db19",
	"./Sale.png": "85fb",
	"./Sport,  Freizeit & Reisen.jpg": "d6c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d021";